module.exports = __webpack_public_path__ + "static/media/dumbledore.7f34514d.jpg";